import { render, staticRenderFns } from "./CreateProformaPage.vue?vue&type=template&id=c4c4f6b8"
import script from "./CreateProformaPage.vue?vue&type=script&lang=js"
export * from "./CreateProformaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports